import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getFeatureAccess } from '../utils/accessUtils';

const useFeatureAccess = (feature) => {
  const user = useSelector(s => s.auth.user);
  const process = useSelector(state => state.process.selectedProcess);
  const now = new Date();

  return useMemo(() => getFeatureAccess(feature, { process, user, now }), [feature, process, user]);
};

export default useFeatureAccess;